
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  SourcingSearchByIdentifierRequest,
  SourcingSearchCodeWithLabel,
  SourcingSearchRequest,
  SourcingSearchResponse,
  ValidationError,
} from '../models';
import {
    SourcingSearchByIdentifierRequestFromJSON,
    SourcingSearchByIdentifierRequestToJSON,
    SourcingSearchCodeWithLabelFromJSON,
    SourcingSearchCodeWithLabelToJSON,
    SourcingSearchRequestFromJSON,
    SourcingSearchRequestToJSON,
    SourcingSearchResponseFromJSON,
    SourcingSearchResponseToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface SourcingSearchOperationRequest {
    sourcingSearchRequest: SourcingSearchRequest;
}

export interface SourcingSearchByIdentifierOperationRequest {
    sourcingSearchByIdentifierRequest: SourcingSearchByIdentifierRequest;
}

export interface SourcingSearchUnregisteredRequest {
    sourcingSearchRequest: SourcingSearchRequest;
}

/**
 * 
 */
export class SourcingSearchApi extends runtime.BaseAPI {

    /**
     * Get all available functional skills for the Supply Explorer
          */
    async getSourcingSearchFunctionalSkillsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<SourcingSearchCodeWithLabel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<SourcingSearchCodeWithLabel>>({
            path: `/search/api/sourcing/ontology/functional-skills`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(SourcingSearchCodeWithLabelFromJSON);
        return response;
    }

    /**
     * Get all available functional skills for the Supply Explorer
          */
    async getSourcingSearchFunctionalSkills(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<SourcingSearchCodeWithLabel>> {
        const response = await this.getSourcingSearchFunctionalSkillsRaw(initOverrides);
        return response._data;
    }

    /**
     * Search freelancers in the Supply Explorer
          */
    async sourcingSearchRaw(requestParameters: SourcingSearchOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SourcingSearchResponse>> {
        if (requestParameters['sourcingSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'sourcingSearchRequest',
                'Required parameter "sourcingSearchRequest" was null or undefined when calling sourcingSearch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SourcingSearchResponse>({
            path: `/search/api/sourcing/manual`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourcingSearchRequestToJSON(requestParameters['sourcingSearchRequest']),
        }, initOverrides);

        if (response._data) { response._data=SourcingSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Search freelancers in the Supply Explorer
          */
    async sourcingSearch(requestParameters: SourcingSearchOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SourcingSearchResponse> {
        const response = await this.sourcingSearchRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Search a freelancer by name, profile URL, or account URL in the Supply Explorer
          */
    async sourcingSearchByIdentifierRaw(requestParameters: SourcingSearchByIdentifierOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SourcingSearchResponse>> {
        if (requestParameters['sourcingSearchByIdentifierRequest'] == null) {
            throw new runtime.RequiredError(
                'sourcingSearchByIdentifierRequest',
                'Required parameter "sourcingSearchByIdentifierRequest" was null or undefined when calling sourcingSearchByIdentifier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SourcingSearchResponse>({
            path: `/search/api/sourcing/identifier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourcingSearchByIdentifierRequestToJSON(requestParameters['sourcingSearchByIdentifierRequest']),
        }, initOverrides);

        if (response._data) { response._data=SourcingSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Search a freelancer by name, profile URL, or account URL in the Supply Explorer
          */
    async sourcingSearchByIdentifier(requestParameters: SourcingSearchByIdentifierOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SourcingSearchResponse> {
        const response = await this.sourcingSearchByIdentifierRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Search unregistered freelancers
          */
    async sourcingSearchUnregisteredRaw(requestParameters: SourcingSearchUnregisteredRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SourcingSearchResponse>> {
        if (requestParameters['sourcingSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'sourcingSearchRequest',
                'Required parameter "sourcingSearchRequest" was null or undefined when calling sourcingSearchUnregistered().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SourcingSearchResponse>({
            path: `/search/api/sourcing/unregistered`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourcingSearchRequestToJSON(requestParameters['sourcingSearchRequest']),
        }, initOverrides);

        if (response._data) { response._data=SourcingSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Search unregistered freelancers
          */
    async sourcingSearchUnregistered(requestParameters: SourcingSearchUnregisteredRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SourcingSearchResponse> {
        const response = await this.sourcingSearchUnregisteredRaw(requestParameters, initOverrides);
        return response._data;
    }

}
